// @flow

import React from 'react';
import { reduxForm } from 'redux-form';
import type { FormProps } from 'redux-form';
import type { ACFformBuilder } from '../../types/acf';
import { Form } from '../form';
import { FormElement } from './atoms';
import { elementMapping } from './helpers';

type Props = {
  onSubmit: Function,
  elements: ACFformBuilder,
  form: string,
} & FormProps;

const FormBuilder = ({
  elements,
  form,
  onSubmit,
  handleSubmit,
}: Props) => (
  <Form
    form={form}
    onSubmit={handleSubmit(onSubmit)}
  >
    {elements.map((element, index) => (
      <FormElement
        element={element}
        elementMapping={elementMapping}
        key={`form-element-${index}`} // eslint-disable-line
      />
    ))}
  </Form>
);

export default reduxForm()(FormBuilder);
